import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import {
  ModalService,
  ObservableHandlerPair
} from 'src/app/services/modal.service';
import { production } from 'src/globals/globals';
import { ImmoOverviewStateService } from '../../services/immo-overview-state.service';
import { CreateEditTaskModalComponent } from './task/create-edit-task/create-edit-task-modal.component';
import { TestUnassignedExpiredSubProjectsModalComponent } from './test-unassign-expired-subprojects/test-unassign-expired-subprojects-modal.component';

@Component({
  selector: 'immo-ip',
  templateUrl: './immo-ip.component.html',
  styleUrls: ['./immo-ip.component.scss']
})
export class ImmoIpComponent implements OnInit, OnDestroy {
  selectedOverview: string;

  countNew = 0;
  countPrint = 0;
  countDesign = 0;
  countAppointment = 0;
  countAtelier = 0;
  countNonExecuted = 0;
  countBilling = 0;
  countCompleted = 0;

  production = production;

  taskCreatedOrEdited = new Subject<never>();

  constructor(
    private immoOverviewStateService: ImmoOverviewStateService,
    private modalService: ModalService,
    private subProjectService: SubProjectControllerRequestService
  ) {}

  ngOnInit() {
    this.selectedOverview = this.immoOverviewStateService.getSelectedView();
    this.subProjectService.getImmoNonExecutedCount().then(res => {
      this.countNonExecuted = res;
    });
  }

  ngOnDestroy(): void {
    if (this.taskCreatedOrEdited != null) {
      this.taskCreatedOrEdited.complete();
      this.taskCreatedOrEdited = null;
    }
  }

  changeSelectedView(value: string) {
    this.selectedOverview = value;
    this.immoOverviewStateService.setSelectedView(value);
  }

  updateNewCount(count: number) {
    this.countNew = count;
  }

  updatePrintCount(count: number): void {
    this.countPrint = count;
  }

  updateDesignCount(count: number): void {
    this.countDesign = count;
  }

  updateAppointmentCount(count: number): void {
    this.countAppointment = count;
  }

  updateAtelierCount(count: number): void {
    this.countAtelier = count;
  }

  updateNonExecutedCount(count: number): void {
    this.countNonExecuted = count;
  }

  updateBillingCount(count: number): void {
    this.countBilling = count;
  }

  updateCompletedCount(count: number): void {
    this.countCompleted = count;
  }

  openTestUnassignedExpiredSubProjectsModal(): void {
    this.modalService.openComponentInModal(
      TestUnassignedExpiredSubProjectsModalComponent,
      [],
      new ObservableHandlerPair(
        modalRef => modalRef.componentInstance.success,
        () => this.changeSelectedView('non-executed')
      )
    );
  }

  openCreateEditTaskModal(): void {
    this.modalService.openComponentInModal(
      CreateEditTaskModalComponent,
      [],
      new ObservableHandlerPair(
        modalRef => modalRef.componentInstance.result,
        result => {
          if (result === 'taskCreatedOrEdited') {
            this.taskCreatedOrEdited.next();
          }
        }
      ),
      { minWidth: '97vw', height: '95vh' }
    );
  }
}
